import HTTP from './http'
const BASE_URL = '/document'
import makeS3SafeFileName from '@/helpers/makeS3SafeFileName'
import { last } from 'lodash-es'

export default {
  /*
  this is what a "documentDetails" object looks like

  {
  "documentName": "maurice-test.png",
	"documentHolder": "carrier",
	"documentType": "qualification",
	"documentHolderKey": "63",
	"documentData": ""
	}
   */

  /**
   * Upload a file
   * @param {Object} documentDetails
   * @param {Boolean} replace If true will try to replace the file, otherwise will create a new one (default to false)
   * @returns {Promise<*>}
   */
  async upload(documentDetails, replace = false) {
    const action = replace ? 'put' : 'post'

    // handle any special characters that might be in the file name
    // ref: https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingMetadata.html#object-key-guidelines
    documentDetails.documentName = makeS3SafeFileName(documentDetails.documentName)
    const response = await HTTP[action](BASE_URL, documentDetails)
    return response.data.data
  },

  async uploadBulk(documents) {
    const response = await HTTP.post(`${BASE_URL}/list`, documents)
    return response.data.data
  },

  async getByKey(documentKey) {
    const response = await HTTP.get(BASE_URL, { params: { documentKey } })
    return response.data.data
  },

  async getS3ByKey(documentS3Key) {
    const response = await HTTP.get(BASE_URL, { params: { documentS3Key } })
    return response.data.data
  },

  async delete(documentKey) {
    return HTTP.delete(BASE_URL, { params: { documentKey } })
  },

  async list({ companyKey, accountKey, companyJobKey }) {
    const blackListExtensions = ['html', 'json', 'doc', 'docx']

    const response = await HTTP.get(`${BASE_URL}/list`, { params: { companyKey, accountKey, companyJobKey } })
    return response.data.data.filter((doc) => {
      const extension = last(doc.documentName.split('.')).toLowerCase()
      return !blackListExtensions.includes(extension)
    })
  },

  async copy({ documentKey, copyToDocumentHolderKey, copyToDocumentHolder }) {
    const response = await HTTP.post(`${BASE_URL}/copy`, { documentKey, copyToDocumentHolderKey, copyToDocumentHolder })
    return response.data.data
  }
}
